import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { PolicyDetailsService } from '../services/policydetails.service';
import { MyPoliciesSearchHandler } from './my-policies-search.handler';

@Component({
  selector: 'sym-my-policies-search',
  templateUrl: './my-policies-search.component.html',
  styleUrls: ['./my-policies-search.component.scss'],
})
export class MyPoliciesSearchComponent extends MyPoliciesSearchHandler implements OnInit {
  constructor(
    public service: PolicyDetailsService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
